import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { css } from "styled-components";

addToListModalStyles.signInMessageText = {
    css: css`
        a {
            text-decoration: underline;
            font-weight: 600;
        }
    `,
};
